<!--
  ~ This code is protected by intellectual property rights.
  ~ Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
  ~ © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
  -->

<div class="profile:pt-10">
  @if (backLink) {
    <div class="profile:pb-fluid-lg">
      <profile-pds-p-link-pure p-link-pure [icon]="'arrow-head-left'" [href]="href">
        {{ linkValue | async }}
      </profile-pds-p-link-pure>
    </div>
  }
  <profile-pds-p-heading p-heading [tag]="'h1'" class="profile:pb-fluid-md" weight="bold">{{ title }}</profile-pds-p-heading>
</div>
